module.exports = __webpack_public_path__ + "6481c5e2001a20fa35bf716437526a1b.svg";